<template>
  <div class="py-2 px-4">
    <v-row class="px-3">
      <div class="d-flex col-12 pt-0">
        <v-checkbox
          v-model="sendEmail"
          label="Activer l’envoi de l’email transactionnel"
          color="third"
          hide-details
        />
      </div>
      <v-col cols="6">
        <v-card>
          <v-card-title>
            <v-chip
              class="pointer"
              color="gray"
              label
              outlined
            >
              Clients Sélectionné ({{ selectedAssignCustomer.length }})
            </v-chip>
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="clientSearch"
              color="third"
              append-icon="mdi-magnify"
              label="Search Clients"
              placeholder="Search Clients"
              single-line
              hide-details
              class="pb-4 pt-0 mt-0"
              @click.stop
            />
            <v-data-table
              :headers="clientHeaders"
              :items="selectedAssignCustomer"
              :search="clientSearch"
              :items-per-page="-1"
              :hide-default-footer="true"
              height="500"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card>
          <v-card-title>
            <v-chip
              class="pointer"
              color="gray"
              label
              outlined
            >
              Product Sélectionné ({{ selectedAssignProducts.length }})
            </v-chip>
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="productSearch"
              color="third"
              append-icon="mdi-magnify"
              label="Search Products"
              placeholder="Search Products"
              single-line
              hide-details
              class="pb-4 pt-0 mt-0"
              @click.stop
            />
            <v-data-table
              :headers="productHeaders"
              :items="selectedAssignProducts"
              :search="productSearch"
              :items-per-page="-1"
              :hide-default-footer="true"
              height="500"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-row justify="center" class="ma-4">
        <v-btn color="third" class="white--text" height="32" :disabled="!isButtonEnable" @click="submitProductCustomerAssign()">
          Valider
        </v-btn>
      </v-row>
    </v-row>
  </div>
</template>

<script>
import { ref, computed, inject } from '@vue/composition-api';

export default {
  setup () {
    const submitProductCustomerAssign = inject('submitProductCustomerAssign');
    const productHeaders = inject('productHeaders');
    const clientHeaders = inject('clientHeaders');
    const selectedAssignCustomer = inject('selectedAssignCustomer');
    const selectedAssignProducts = inject('selectedAssignProducts');
    const sendEmail = inject('sendAllowProductEmail');

    const clientSearch = ref(null);
    const productSearch = ref(null);

    const isButtonEnable = computed(() => selectedAssignCustomer.value.length && selectedAssignProducts.value.length);

    return { sendEmail, selectedAssignCustomer, selectedAssignProducts, productHeaders, clientHeaders, clientSearch, productSearch, isButtonEnable, submitProductCustomerAssign };
  }
};
</script>
